import { stringOrNull, TMaybe } from "../helpers/TsHelpers";

export type TFolder = {
  id: string;
  depth: number;
  type: "FOLDER";
  matterId: string;
  parentId: string;
  name: TMaybe<string>;
  subFolders: TFolder[];
  dateCreated: TMaybe<string>;
  dateModified: TMaybe<string>;
};

export const drawTreeAsString = (root: TFolder, indent: number = 0): string => {
  if (!root) {
    return "";
  }

  const indentString = " ".repeat(indent * 2);
  let output = `${indentString}- ${root.name} [${root.id}]\n`;

  root.subFolders?.forEach((folder) => {
    output += drawTreeAsString(folder, indent + 1);
  });

  return output;
};

export const buildAsTree = (matterId: string, folders: TFolder[]): TFolder => {
  const folderMap: { [id: string]: TFolder } = {};

  // Populate folderMap and find the root folder
  let rootFolder: TFolder | null = null;

  const createRoot = (id: string | undefined | null | "", matterId: string): TFolder => {
    return {
      id: id,
      depth: 0,
      parentId: id,
      subFolders: [],
      type: "FOLDER",
      name: "Documents",
      dateCreated: null,
      matterId: matterId,
      dateModified: null,
    } as TFolder;
  };

  folders.forEach((folder) => {
    folder.subFolders = [];
    folderMap[folder.id] = folder;

    if (!folder.parentId || folder.parentId === "" || folder.parentId === null || folder.parentId === undefined) {
      if (!rootFolder) {
        rootFolder = createRoot(folder.parentId, folder.matterId);
      }
    }
  });

  if (!rootFolder) {
    rootFolder = createRoot(null, matterId);
  }

  const stack: { folder: TFolder; depth: number }[] = [{ folder: rootFolder, depth: 0 }];

  while (stack.length > 0) {
    const { folder, depth } = stack.pop()!;
    folder.depth = depth;

    folders.forEach((childFolder) => {
      if (childFolder.parentId === folder.id) {
        const childDepth = depth + 1;

        const child = { ...childFolder, depth: childDepth };
        folder.subFolders.push(child);

        stack.push({ folder: child, depth: childDepth });
      }
    });
  }

  return rootFolder;
};

// eslint-disable-next-line -- unless we want to generate types from the schema
export const mapFolderFromGQL = (matterId: string, raw: any) => {
  if (!raw) {
    return null;
  }

  if (raw.id && typeof raw.id === "string") {
    const folder: TFolder = {
      depth: 0,
      id: raw.id,
      type: "FOLDER",
      subFolders: [],
      matterId: matterId,
      parentId: raw.parentId,
      name: stringOrNull(raw.name),
      dateCreated: stringOrNull(raw.dateCreated),
      dateModified: stringOrNull(raw.lastUpdatedUtc),
    };

    return folder;
  }

  return null;
};
